import { createAction, props } from '@ngrx/store';

import { UserModel } from '@lockton-apps/client-gateway/interfaces';

import { UserCreateUpdateActionTypes } from './actions.model';

//  User Create Update
export const init = createAction(UserCreateUpdateActionTypes.Init);

export const initCreate = createAction(UserCreateUpdateActionTypes.InitCreate);

export const initUpdate = createAction(UserCreateUpdateActionTypes.InitUpdate);

export const add = createAction(
  UserCreateUpdateActionTypes.Add,
  props<{ userModel: UserModel }>()
);

export const update = createAction(
  UserCreateUpdateActionTypes.Update,
  props<{ userModel: UserModel }>()
);

export const destroyed = createAction(UserCreateUpdateActionTypes.Destroyed);
